import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { PMPluginFactoryParams } from '@atlaskit/editor-common/types';

import { createPluginState } from './plugin-factory';
import { rovoAgentsPluginKey } from './plugin-key';
import type { RovoAgentsPluginState } from './states';

export function createRovoAgentsPlugin(options: PMPluginFactoryParams): SafePlugin<RovoAgentsPluginState> {
	return new SafePlugin({
		key: rovoAgentsPluginKey,
		state: createPluginState(
			options.dispatch,
			// Initial state
			{
				agents: [],
				enabled: false,
				publish: () => {},
				isBrowseModalOpen: false,
				positions: undefined,
				initialised: false,
			},
		),
	});
}
